import { ApolloClient } from '@apollo/client';
import { hasLength, isNumber, isString } from '@perch-labs/warbler';
import {
  Flex_ValidateUtilityAndZipQuery,
  Flex_ValidateUtilityAndZipQueryVariables,
} from '~/typings/graphql';
import { UnparsedQueryParams } from '../../types';
import { VALIDATE_UTILITY_AND_ZIP } from './handle-utility-id-and-zip-code.queries';

export const handleUtilityIdAndZipCode = async ({
  apolloClient,
  params,
}: {
  apolloClient: ApolloClient<{}>;
  params: UnparsedQueryParams;
}) => {
  const { utilityId } = params;
  const zipCode = params.zipCode || params.zip;

  const variables: Flex_ValidateUtilityAndZipQueryVariables = {};
  if (isNumber(utilityId)) variables.utilityId = utilityId;
  if (isString(zipCode) && zipCode.length === 5) variables.zipCode = zipCode;

  if (!hasLength(variables)) return;

  const { data } = await apolloClient.query<
    Flex_ValidateUtilityAndZipQuery,
    Flex_ValidateUtilityAndZipQueryVariables
  >({
    query: VALIDATE_UTILITY_AND_ZIP,
    variables,
  });

  const validation = data?.validation;

  if (validation?.zipCodeAndUtility?.isValid) {
    return { utilityId, zipCode };
  } else if (validation?.utility?.isValid) {
    return { utilityId };
  } else if (validation?.zipCode?.isValid) {
    return { zipCode };
  }

  return undefined;
};
